module.exports = __webpack_public_path__ + "img/keisi_logo.acbc6888.png";